import { clearFullPolicyDetails } from '@acorn-portal/shared/src/store/fullPolicy.slice';
import { clearMidTermAdjustmentDetails } from '@acorn-portal/shared/src/store/midTermAdjustment.slice';
import { resetApiMTA } from '@acorn-portal/shared/src/store/midTermAdjustmentAPI.sclice';
import { clearMidTermAdjustmentResponseDetails } from '@acorn-portal/shared/src/store/midTermAdjustmentRatingResponse.slice';
import { clearPayNowDetails } from '@acorn-portal/shared/src/store/paynow.slice';
import { clearRenewalState } from '@acorn-portal/shared/src/store/renewal.slice';
import { resetRenewalChanges } from '@acorn-portal/shared/src/store/renewalChanges.slice';
import { clearDocuments } from '@acorn-portal/shared/src/store/policyDocuments.slice';
import { useAppDispatch } from '@acorn-portal/shared/src/hooks/reduxHook';
import { clearContactPreferences } from '@acorn-portal/shared/src/store/contactPreferences.slice';
import { clearManagedPaymentsDetails } from '@acorn-portal/shared/src/store/managedPayments.slice';
import { resetCancellationData } from '@acorn-portal/shared/src/store/cancellation/cancellation.slice';

export default function useClearStore() {
	const dispatch = useAppDispatch();
	const clearStore = () => {
		dispatch(clearDocuments());
		dispatch(clearPayNowDetails());
		dispatch(clearMidTermAdjustmentDetails());
		dispatch(clearMidTermAdjustmentResponseDetails());
		dispatch(clearManagedPaymentsDetails());
		dispatch(resetApiMTA());
		dispatch(clearFullPolicyDetails());
		dispatch(clearRenewalState());
		dispatch(resetRenewalChanges());
		dispatch(clearContactPreferences());
		dispatch(resetCancellationData());
	};

	return { clearStore };
}
